import type { useForm } from "hooks";
import type { Moment } from "moment";
import type { BootstrapableForm } from "types";
import type { OnboardingFormProps } from "ui/forms/ECommerce/Onboarding/types";
import { Identity } from "./entities";

export const FormField = {
    AuthSigAddressLine1: 'authSigAddressLine1',
    AuthSigAddressLine2: 'authSigAddressLine2',
    AuthSigCity: 'authSigCity',
    AuthSigName: 'authSigName',
    AuthSigCountryOrigin: 'authSigCountryOrigin',
    AuthSigDateOfBirth: 'authSigDateOfBirth',
    AuthSigEmail: 'authSigEmail',
    AuthSigPassportExpDate: 'authSigPassportExpDate',
    AuthSigPassportNumber: 'authSigPassportNumber',
    AuthSigPhone: 'authSigPhone',
    AuthSigPostalCode: 'authSigPostalCode',
    AuthSigTitle: 'authSigTitle',
    CeoAddressLine1: 'ceoAddressLine1',
    CeoAddressLine2: 'ceoAddressLine2',
    CeoCity: 'ceoCity',
    CeoCountryOrigin: 'ceoCountryOrigin',
    CeoDateOfBirth: 'ceoDateOfBirth',
    CeoEmail: 'ceoEmail',
    CeoName: 'ceoName',
    CeoPassportExpDate: 'ceoPassportExpDate',
    CeoPassportNumber: 'ceoPassportNumber',
    CeoPhone: 'ceoPhone',
    CeoPostalCode: 'ceoPostalCode',
    CeoTitle: 'ceoTitle',
    OtherPeople: {
        Name: 'name',
        AddressLine1: 'addressLine1',
        AddressLine2: 'addressLine2',
        City: 'city',
        PostalCode: 'postalCode',
        CountryOrigin: 'countryOrigin',
        DateOfBirth: 'dateOfBirth',
        PassportNumber: 'passportNumber',
        PassportExpDate: 'passportExpDate',
        Title: 'title',
        Email: 'email',
        Phone: 'phone',
    }
} as const;

export type OtherPeopleIdentity = Identity;

export type OnboardingDirectorsAndShareholders = {
    readonly [FormField.AuthSigAddressLine1]: string;
    readonly [FormField.AuthSigAddressLine2]: string;
    readonly [FormField.AuthSigCity]: string;
    readonly [FormField.AuthSigCountryOrigin]: string | null;
    readonly [FormField.AuthSigDateOfBirth]: Moment | null;
    readonly [FormField.AuthSigEmail]: string;
    readonly [FormField.AuthSigName]: string;
    readonly [FormField.AuthSigPassportExpDate]: Moment | null;
    readonly [FormField.AuthSigPassportNumber]: string;
    readonly [FormField.AuthSigPhone]: string;
    readonly [FormField.AuthSigPostalCode]: string;
    readonly [FormField.AuthSigTitle]: string;
    readonly [FormField.CeoAddressLine1]: string;
    readonly [FormField.CeoAddressLine2]: string;
    readonly [FormField.CeoCity]: string;
    readonly [FormField.CeoCountryOrigin]: string | null;
    readonly [FormField.CeoDateOfBirth]: Moment | null;
    readonly [FormField.CeoEmail]: string;
    readonly [FormField.CeoName]: string;
    readonly [FormField.CeoPassportExpDate]: Moment | null;
    readonly [FormField.CeoPassportNumber]: string;
    readonly [FormField.CeoPhone]: string;
    readonly [FormField.CeoPostalCode]: string;
    readonly [FormField.CeoTitle]: string;
    readonly otherPeople: Array<OtherPeopleIdentity>;
};

export type OnboardingDirectorsAndShareholdersBootstrapData = {};

export type OnboardingDirectorsAndShareholdersForm = Omit<
    BootstrapableForm<OnboardingDirectorsAndShareholders, OnboardingDirectorsAndShareholdersBootstrapData>,
    | 'initialValues'
> & {
    readonly initialValues: OnboardingDirectorsAndShareholders;
};

export type OnboardingDirectorsAndShareholdersProps =
    & OnboardingFormProps
    & OnboardingDirectorsAndShareholdersForm
    & ReturnType<typeof useForm<OnboardingDirectorsAndShareholders>>;
